export const LABEL_OMEGA_CLASSIFICATION = {
  NORMAL: 'Normal',
  ALERT: 'Alerta',
  CRITICAL: 'Crítico',
  VERY_CRITICAL: 'Muito Crítico',
} as const;

export const REF_COLOR_VALUE: {
  [key: string]: {
    green: string | number;
    yellow: string | number;
    orange: string | number;
    red: string | number;
  };
} = {
  h2: {
    green: 100,

    yellow: 700,

    orange: 1800,

    red: 1800,
  },
  co2: {
    green: 2500,

    yellow: 4000,

    orange: 10000,

    red: 10000,
  },
  c2h4: {
    green: 50,

    yellow: 100,

    orange: 200,

    red: 200,
  },
  c2h6: {
    green: 65,

    yellow: 100,

    orange: 150,

    red: 150,
  },
  c2h2: {
    green: 1,

    yellow: 9,

    orange: 35,

    red: 35,
  },
  co: {
    green: 350,

    yellow: 570,

    orange: 1400,

    red: 1400,
  },
  ch4: {
    green: 120,

    yellow: 400,

    orange: 1000,

    red: 1000,
  },
  tgc: {
    green: 720,

    yellow: 1920,

    orange: 4630,

    red: 4630,
  },
  iecC57: {
    green: LABEL_OMEGA_CLASSIFICATION.NORMAL,
    yellow: LABEL_OMEGA_CLASSIFICATION.ALERT,
    orange: LABEL_OMEGA_CLASSIFICATION.CRITICAL,
    red: LABEL_OMEGA_CLASSIFICATION.VERY_CRITICAL,
  },
  classification: {
    green: LABEL_OMEGA_CLASSIFICATION.NORMAL,
    yellow: LABEL_OMEGA_CLASSIFICATION.ALERT,
    orange: LABEL_OMEGA_CLASSIFICATION.CRITICAL,
    red: LABEL_OMEGA_CLASSIFICATION.VERY_CRITICAL,
  },
  omegaClassification: {
    green: LABEL_OMEGA_CLASSIFICATION.NORMAL,
    yellow: LABEL_OMEGA_CLASSIFICATION.ALERT,
    orange: LABEL_OMEGA_CLASSIFICATION.CRITICAL,
    red: LABEL_OMEGA_CLASSIFICATION.VERY_CRITICAL,
  },
};
